export default "__VITE_ASSET__k_RK6sUT__"